export default __webpack_public_path__ + "static/media/login_6.2800a257.jpg";